import {useState} from 'react';

const faqs = [
  {question: 'What does Florida HVAC training usually cover?', answer: 'Programs commonly combine safety, tools, refrigeration principles, electrical theory, air distribution, motors, controls, heating systems, cooling systems, preventive maintenance, and system diagnostics. Strong hands-on programs also provide wiring, meters, component identification, and troubleshooting practice.'},
  {question: 'Should I look for EPA Section 608 certification preparation?', answer: 'Yes. Technicians who handle regulated refrigerants generally need EPA Section 608 certification. Ask each Florida school whether testing is included, which certification types the curriculum supports, and whether additional state requirements apply.'},
  {question: 'Is online HVAC training enough to become job-ready?', answer: 'Online study can help with theory, terminology, safety, and flexible learning. HVAC work is highly practical, so compare online programs with options that include mechanical labs, diagnostic equipment, instructor demonstrations, or supervised field experience.'},
  {question: 'How long does it take to complete an HVAC program?', answer: 'Florida options range from several-month certificate programs to 750-clock-hour technical certificates, associate degrees, and advanced university pathways. Ask about total clock hours, lab hours, attendance requirements, and the timeline for full-time enrollment.'},
  {question: 'What should I ask a school before applying?', answer: 'Ask for tuition and fee details, tool costs, books, class times, lab access, instructor experience, EPA preparation, credentials, job placement support, refund policies, admission requirements, and relationships with Florida employers.'},
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <section className="directory section" id="faq">
      <div className="section-heading">
        <p className="eyebrow">Plan with confidence</p>
        <h2>Florida HVAC Training FAQs</h2>
        <p>Use these answers as a starting point while comparing Florida programs. School representatives provide the most current information about curriculum, credentials, costs, and enrollment.</p>
      </div>
      <div className="accordion-stack">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <article className={`program-card ${isOpen ? 'open' : ''}`} key={faq.question}>
              <button className="program-trigger" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen}>
                <strong>{faq.question}</strong><span aria-hidden="true">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && <div className="program-inner"><p>{faq.answer}</p></div>}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;